<template>
  <b-modal
    v-bind:visible="visible"
    v-bind:title="title"
    :size="size"
    centered
    ok-only
    ok-variant="danger"
    @hidden="updateVmodel"
  >
    <template v-slot:modal-footer="{ ok }">
      <slot name="leftOfButton"></slot>
      <b-button variant="danger" @click="ok()">{{ positiveText }}</b-button>
    </template>
    <p class="my-2">
      <slot></slot>
    </p>
  </b-modal>
</template>

<script>
export default {
  name: "DialogError",
  props: {
    title: {
      default: "Error"
    },
    visible: {
      default: false
    },
    positiveText: {
      default: "OK"
    },
    size: {
      default: ""
    }
  },
  model: {
    prop: "visible",
    event: "hidden"
  },
  methods: {
    updateVmodel() {
      this.$emit("hidden", false);
    }
  }
};
</script>
